import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiMapPin } = FiIcons;
const venues = [
  {
    day: 'SÁBADO 14 · ESCUELA DE LIDERAZGO',
    name: 'Hotel Fiesta Inn Plaza San Marcos',
    address: 'Avenida Chalma esquina Autopista México-Querétaro, lote 8, colonia Jardines de la Hacienda Norte, C.P. 54700, Cuautitlán Izcalli.',
    map: 'https://www.google.com/maps/search/?api=1&query=Hotel+Fiesta+Inn+Plaza+San+Marcos+Cuautitlan+Izcalli'
  }
];

export default function Venues() {
  return (
    <section className="section venues-section" id="sedes">
      <div className="container">
        <div className="section-top"><span className="eyebrow">05 / UBICACIONES</span><span className="section-rule" /></div>
        <div className="section-intro"><h2>Nos vemos<br /><span>en Izcalli.</span></h2><p>Una sola sede, una experiencia que vale la pena vivir en persona.</p></div>
        <div className="venues-grid single">
          {venues.map((venue, index) => (
            <article className="venue-card" key={venue.name}>
              <span className="venue-index">0{index + 1}</span>
              <div className="venue-icon"><SafeIcon icon={FiMapPin} /></div>
              <span className="eyebrow">{venue.day}</span>
              <h3>{venue.name}</h3>
              <p>{venue.address}</p>
              <a href={venue.map} target="_blank" rel="noopener noreferrer">VER EN GOOGLE MAPS <SafeIcon icon={FiArrowUpRight} /></a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}